import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 微信通知消息
 */
export class WechatNoticeMsgController {
    constructor() {
        this.baseurl = 'WechatNoticeMsgController.assx/';
    }

    /**
     * 获取 接收消息详情
     * token:String, keyId:String
     */
    GetRepeatMsgDetail(token, keyId){
        return request.post(this.baseurl + 'GetRepeatMsgDetail', Qs.stringify({ token:token, keyId:keyId }));
    }
    /**
     * 微信通知消息,修改截止时间
     * token:String, keyId:String, stopDate:Date
     */
    UpdateWeChatNoticeMsgStopDate(token, keyId, stopDate){
      return request.post(this.baseurl + 'UpdateWeChatNoticeMsgStopDate', Qs.stringify({ token:token, keyId:keyId, stopDate:stopDate }));
    }
    /**
     * 获取通知消息列表  1: 获取发送的通知列表，2: 获取用户接收的通知列表 .
     * token:String, title:String, startDate:String, endDate:String, msgType:int, option:int, startIndex:int, maxSize:int
     */
    GetWeChatNoticeMsgListByOption(token, title, startDate, endDate, msgType, option, startIndex, maxSize){
        return request.post(this.baseurl + 'GetWeChatNoticeMsgListByOption', Qs.stringify({ token:token, title:title, startDate:startDate, endDate:endDate, msgType:msgType, option:option, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 通过通知消息Id 获取我的回复消息
     * token:String, msg:WeChatNoticeMsg, attachMentIds:String
     */
    SendWeChatNoticeMsg(token, msg, attachMentIds){
        return request.post(this.baseurl + 'SendWeChatNoticeMsg', Qs.stringify({ token:token, msg:typeof msg === 'undefined' || msg === null ? '' : msg.toString(), attachMentIds:attachMentIds }));
    }

    /**
     * 获取某个回复的与会人员列表
     * token:String, repeatId:String, startIndex:int, maxSize:int
     */
    GetRepeatMeetingMemberList(token, repeatId, startIndex, maxSize){
        return request.post(this.baseurl + 'GetRepeatMeetingMemberList', Qs.stringify({ token:token, repeatId:repeatId, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 通过openId获取某用户接收到的通知消息列表  (只查询未删除) .
     * token:String, para:ReceiveRepeatMsgQueryPara, startIndex:int, maxSize:int
     */
    GetWeChatNoticeMsgListByReceivedByOpenId(token, para, startIndex, maxSize){
        return request.post(this.baseurl + 'GetWeChatNoticeMsgListByReceivedByOpenId', Qs.stringify({ token:token, para:typeof para === 'undefined' || para === null ? '' : para.toString(), startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 生成扫码签到二维码
     * token:String, noticeId:String
     */
    ScanNoticeSignedIn(token, noticeId){
        return request.post(this.baseurl + 'ScanNoticeSignedIn', Qs.stringify({ token:token, noticeId:noticeId }));
    }

    /**
     * 添加与会人员
     * token:String, repeatId:String, mettingMember:MettingMember, sendMsg:boolean
     */
    AddmettingMember(token, repeatId, mettingMember, sendMsg){
        return request.post(this.baseurl + 'AddmettingMember', Qs.stringify({ token:token, repeatId:repeatId, mettingMember:typeof mettingMember === 'undefined' || mettingMember === null ? '' : mettingMember.toString(), sendMsg:sendMsg }));
    }

    /**
     * 获取通知消息详情
     * token:String, keyId:String
     */
    GetWeChatNoticeMsgDetail(token, keyId){
        return request.post(this.baseurl + 'GetWeChatNoticeMsgDetail', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 获取整个通知与会人员列表
     * token:String, noticeId:String, startIndex:int, maxSize:int
     */
    GetNoticeMeetingMemberList(token, noticeId, startIndex, maxSize){
        return request.post(this.baseurl + 'GetNoticeMeetingMemberList', Qs.stringify({ token:token, noticeId:noticeId, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取通知消息列表  (只查询未删除) .
     * token:String, para:WeChatNoticeMsgQueryPara, startIndex:int, maxSize:int
     */
    GetWeChatNoticeMsgList(token, para, startIndex, maxSize){
        return request.post(this.baseurl + 'GetWeChatNoticeMsgList', Qs.stringify({ token:token, para:typeof para === 'undefined' || para === null ? '' : para.toString(), startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取最近两次通知消息情况
     * token:String, size:int
     */
    GetNextNoticeInfo(token, size){
        return request.post(this.baseurl + 'GetNextNoticeInfo', Qs.stringify({ token:token, size:size }));
    }

    /**
     * 根据当前用户获取可以发送消息的区域列表
     * token:String
     */
    GetMsgSendRegion(token){
        return request.post(this.baseurl + 'GetMsgSendRegion', Qs.stringify({ token:token }));
    }

    /**
     * 删除与会人员
     * token:String, memberKeyId:String
     */
    DeleteMettingMember(token, memberKeyId){
        return request.post(this.baseurl + 'DeleteMettingMember', Qs.stringify({ token:token, memberKeyId:memberKeyId }));
    }

    /**
     * 回复消息
     * token:String, msg:ReceiveRepeatMsg, attachMentIds:String, isDefault:boolean
     */
    RepeatNoticeMsg(token, msg, attachMentIds, isDefault){
        return request.post(this.baseurl + 'RepeatNoticeMsg', Qs.stringify({ token:token, msg:typeof msg === 'undefined' || msg === null ? '' : msg.toString(), attachMentIds:attachMentIds, isDefault:isDefault }));
    }

    /**
     * 给与会人员发送验证码
     * token:String, noticeId:String, phoneNum:String
     */
    sendMsg2MettingMember(token, noticeId, phoneNum){
        return request.post(this.baseurl + 'sendMsg2MettingMember', Qs.stringify({ token:token, noticeId:noticeId, phoneNum:phoneNum }));
    }

    /**
     * 验证与会人员手机验证码
     * token:String, noticeId:String, repeatId:String, phoneNum:String, phoneCode:String
     */
    AutherRepeatMemttingMemberPhoneCode(token, noticeId, repeatId, phoneNum, phoneCode){
        return request.post(this.baseurl + 'AutherRepeatMemttingMemberPhoneCode', Qs.stringify({ token:token, noticeId:noticeId, repeatId:repeatId, phoneNum:phoneNum, phoneCode:phoneCode }));
    }

    /**
     * 签到统计
     * token:String, noticeId:String
     */
    SignedInStatics(token, noticeId){
        return request.post(this.baseurl + 'SignedInStatics', Qs.stringify({ token:token, noticeId:noticeId }));
    }

    /**
     * 与会人员签到
     * token:String, mettingMember:MettingMember, phoneCode:String
     */
    MettingMemberSigned(token, mettingMember, phoneCode){
        return request.post(this.baseurl + 'MettingMemberSigned', Qs.stringify({ token:token, mettingMember:typeof mettingMember === 'undefined' || mettingMember === null ? '' : mettingMember.toString(), phoneCode:phoneCode }));
    }

    /**
     * 更新回复状态
     * token:String, keyId:String
     */
    UpdateRepeatStatus(token, keyId){
        return request.post(this.baseurl + 'UpdateRepeatStatus', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 获取当前用户下的从业人员或者业委会成员
     * token:String, noticeId:String, repeatId:String, startIndex:int, maxSize:int
     */
    GetEmployeeOrCommitteMember(token, noticeId, repeatId, startIndex, maxSize){
        return request.post(this.baseurl + 'GetEmployeeOrCommitteMember', Qs.stringify({ token:token, noticeId:noticeId, repeatId:repeatId, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 通过通知Id获取回复消息详情列表
     * token:String, keyId:String, startIndex:int, maxSize:int
     */
    GetRepeatMsgListByNoticeId(token, keyId, startIndex, maxSize){
        return request.post(this.baseurl + 'GetRepeatMsgListByNoticeId', Qs.stringify({ token:token, keyId:keyId, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 通过通知消息Id 获取我的回复消息
     * token:String, noticeId:String
     */
    GetMyRepeatDetailByNoticeId(token, noticeId){
        return request.post(this.baseurl + 'GetMyRepeatDetailByNoticeId', Qs.stringify({ token:token, noticeId:noticeId }));
    }
}